'use strict';
const ApiToken = require('../../ApiToken');

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	return {
		// update access_token in aptiConfig
		updateAccessToken: function(data) {
			apiConfig.refreshAccessToken(data);
			// also for jQuery calls and embedded eproc-fe pages, which read it from sessionStorage (EPROC-12347)
			ApiToken.storeAccessToken(data);
		},

		// refresh_access_token resource
		token: $resource(
				sCgiBin + '/rest.refresh_access_token', 
				{
					id: sessionID
				},
				{
					// renew: ask for new access_token
					renew: {
						method: 'POST'
					}
				}
			),
		// calculate the refreshInterval based von access_token creationTime and expires_in seconds
		refreshInterval: function() { 

			// convert seconds to milliseconds
			var expireIn = parseInt(apiConfig.$get().accessTokenExpiresIn) * 1000;

			// substract 5% from expire_in time, but renew at least REFRESH_LEAD_SECONDS before expiry,
			// so the new token is ready when an embedded eproc-fe page asks for it (EPROC-12347).
			// The lead is capped at half the lifetime (not the remaining time), otherwise short lifetimes
			// would renew every 2 seconds
			var lifetime = ApiToken.getLifetimeSeconds() * 1000 || expireIn;
			var lead = Math.min(ApiToken.REFRESH_LEAD_SECONDS * 1000, lifetime / 2);
			var refreshIn = Math.min(expireIn - expireIn * 0.05, expireIn - lead);
			
			// if interval is less than 30 seconds, set interval to 2 seconds, to start requesting a new access_token
			if(refreshIn < 30000)
				return 2000;
			else
				return refreshIn;
		}
	}
}
